import { render, staticRenderFns } from "./main.vue?vue&type=template&id=0156a26c&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=0156a26c&prod&lang=scss"
import style1 from "./main.vue?vue&type=style&index=1&id=0156a26c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0156a26c",
  null
  
)

export default component.exports